export default __webpack_public_path__ + "static/media/info.1d000bf5.svg";